import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle, XCircle, Loader } from 'lucide-react';
import { authService } from '@/services/auth.service';

export default function ActivateAccount() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const activateAccount = async () => {
      const token = searchParams.get('token');
      
      if (!token) {
        setStatus('error');
        setMessage('Invalid activation link. Please check your email for the correct link.');
        return;
      }

      try {
        // const result = await authService.activateAccount(token);
        setStatus('success');
        setMessage("Account activated successfully!");
      } catch (error: any) {
        setStatus('error');
        setMessage(error.message || 'Failed to activate account. The link may have expired.');
      }
    };

    activateAccount();
  }, [searchParams]);

  return (
    <div className="card text-center">
      {status === 'loading' && (
        <>
          <Loader className="text-blue-600 animate-spin" size={32} />
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Activating Account</h2>
        </>
      )}
      {status === 'success' && (
        <>
          <CheckCircle className="text-green-600" size={32} />
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Account Activated!</h2>
          <p className="text-gray-600 mb-8">{message}</p>
          <Link to="/login" className="btn btn-primary w-full">
            Continue to Login
          </Link>
        </>
      )}
      {status === 'error' && (
        <>
          <XCircle className="text-red-600" size={32} />
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Activation Failed</h2>
          <p className="text-gray-600 mb-8">{message}</p>
        </>
      )}
    </div>
  );
}
